import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { deleteIssue } from '@ui/features/quote-builder/state/actions/delete-issue';

import { baseGrossMarginChanged } from './base-gross-margin-changed';
import { configuratorQuoteLineAdded } from './configurator-quote-line-added';
import { contributionMarginChanged } from './contribution-margin-changed';
import { costEstimatorOpened } from './cost-estimator-opened';
import { csrCleared } from './csr-cleared';
import { csrSet } from './csr-set';
import { customerContactSelected } from './customer-contact-selected';
import { customerPartIdChanged } from './customer-part-id-changed';
import { dialogClosed } from './dialog-closed';
import { dialogOpened } from './dialog-opened';
import { editableNumberFieldChanged } from './editable-number-field-changed';
import { editableSelectFieldChanged } from './editable-select-field-changed';
import { editableStringFieldChanged } from './editable-string-field-changed';
import { formSubmitted } from './form-submitted';
import { grossMarginChanged } from './gross-margin-changed';
import { issueDrawerClosed } from './issue-drawer-closed';
import { issueDrawerOpened } from './issue-drawer-opened';
import { leadTimeChanged } from './lead-time-changed';
import { leadTimeNotesChanged } from './lead-time-notes-changed';
import { markupFieldChanged } from './markup-field-changed';
import { operationValueChanged } from './operation-value-changed';
import { productOptionSelected } from './product-option-selected';
import { quantityChanged } from './quantity-changed';
import {
  quoteLineDeleted,
  quoteLineDeletionFailed,
  quoteLineDeletionSucceeded,
} from './quote-line-deleted';
import {
  quoteLineEditedInConfigurator,
  quoteLineEditedInConfiguratorClosed,
} from './quote-line-edited-in-configurator';
import { quoteLineInfoTabChanged } from './quote-line-info-tab-changed';
import { quoteLineInfoToggled } from './quote-line-info-toggled';
import { quoteLineSpecsChanged } from './quote-line-specs-changed';
import {
  quoteLineSyncFailed,
  quoteLineSyncSucceeded,
  quoteLineSyncTriggered,
} from './quote-line-synced';
import {
  quotePriceCreated,
  quotePriceCreationFailed,
  quotePriceCreationSucceeded,
} from './quote-price-created';
import {
  quotePriceDeleted,
  quotePriceDeletionFailed,
  quotePriceDeletionSucceeded,
} from './quote-price-deleted';
import {
  quoteUpdateFailed,
  quoteUpdateSucceeded,
  quoteUpdateTriggered,
} from './quote-updated';
import { requirementValueChanged } from './requirement-value-changed';
import { unitCostChanged } from './unit-cost-changed';
import { unitPriceChanged } from './unit-price-changed';
import { upsertIssue } from './upsert-issue';

export const reducers = {
  baseGrossMarginChanged,
  configuratorQuoteLineAdded,
  contributionMarginChanged,
  costEstimatorOpened,
  customerContactSelected,
  csrCleared,
  csrSet,
  customerPartIdChanged,
  deleteIssue,
  dialogClosed,
  dialogOpened,
  editableNumberFieldChanged,
  editableSelectFieldChanged,
  editableStringFieldChanged,
  issueDrawerClosed,
  issueDrawerOpened,
  formSubmitted,
  grossMarginChanged,
  leadTimeChanged,
  leadTimeNotesChanged,
  markupFieldChanged,
  operationValueChanged,
  productOptionSelected,
  quantityChanged,
  quoteLineInfoToggled,
  quoteLineSpecsChanged,
  quoteLineDeleted,
  quoteLineDeletionFailed,
  quoteLineDeletionSucceeded,
  quoteLineEditedInConfigurator,
  quoteLineEditedInConfiguratorClosed,
  quoteLineInfoTabChanged,
  quoteLineSyncFailed,
  quoteLineSyncSucceeded,
  quoteLineSyncTriggered,
  quotePriceCreated,
  quotePriceCreationFailed,
  quotePriceCreationSucceeded,
  quotePriceDeleted,
  quotePriceDeletionFailed,
  quotePriceDeletionSucceeded,
  quoteUpdateTriggered,
  quoteUpdateSucceeded,
  quoteUpdateFailed,
  unitPriceChanged,
  requirementValueChanged,
  upsertIssue,
  unitCostChanged,
};

export type QuoteBuilderActionType = {
  [k in keyof typeof reducers]: `${typeof QUOTE_BUILDER_SLICE_NAME}/${k}`;
}[keyof typeof reducers];

export function quoteBuilderActionType(
  actionType: keyof typeof reducers,
): QuoteBuilderActionType {
  return `${QUOTE_BUILDER_SLICE_NAME}/${actionType}`;
}
